/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { NutrientsResponse } from './NutrientsResponse';

/**
 * A single meal insight as presented to the user
 */
export type MealInsightHistoryResponse = {
    /**
     * Meal insight ID
     */
    id: string;
    /**
     * ID of the uploaded meal image file
     */
    fileId: string;
    /**
     * Meal insight status
     */
    status: MealInsightHistoryResponse.status;
    /**
     * Timestamp the insight record was stored
     */
    createdAt: string;
    /**
     * Wall-clock date/time (with offset) the meal was eaten / the photo was taken, used for day-grouping regardless of the viewer's current timezone. Set on create as described for CreateMealInsightResponse.takenAt (meals logged in Sophie chat use the upload time) and changed only by an explicit takenAt update.
     */
    takenAt: string;
    /**
     * Whether the meal could be identified
     */
    mealIdentified: boolean;
    /**
     * Name of the identified meal
     */
    mealName?: string;
    /**
     * Nutritional analysis text
     */
    insights?: string;
    /**
     * Nutritional details
     */
    nutrients?: NutrientsResponse;
    /**
     * Latest feedback the user gave on this insight
     */
    latestFeedback?: MealInsightHistoryResponse.latestFeedback;
    /**
     * How many times the member has corrected this insight with their own free text. 0 means the card still shows the AI's original reading of the photo.
     */
    refinementCount: number;
};

export namespace MealInsightHistoryResponse {

    /**
     * Meal insight status
     */
    export enum status {
        SUGGESTED = 'SUGGESTED',
        ACCEPTED = 'ACCEPTED',
        REJECTED = 'REJECTED',
        DELETED = 'DELETED',
    }

    /**
     * Latest feedback the user gave on this insight
     */
    export enum latestFeedback {
        GOOD = 'GOOD',
        BAD = 'BAD',
        REMOVED = 'REMOVED',
    }


}

